<template>
  <Row :gutter="20" style="height: 100%">
    <Col
      span="8"
      style="height: 100%"
      v-for="(item, index) in items"
      :key="index"
    >
      <div
        style="height: 100%"
        class="deskblock"
        :style="{ background: item.background }"
      >
        <div class="title">
          <h3>{{ item.title }}</h3>
          <deskTime @time="getData($event, index)" @yytime="getYearData($event, index)"></deskTime>
        </div>

        <h2>
          {{ item.num }} <span class="unit">{{ item.unit }}</span>
        </h2>
        <div class="blockbottom">
          <p>{{ item.mintitle }} / {{ item.unit }}</p>
          <p>
            {{ item.allNum }}
          </p>
        </div>
      </div>
    </Col>
  </Row>
</template>
<script>
import deskTime from "../time.vue";
export default {
  components: { deskTime },
  data() {
    return {
      items: [
        {
          num: 0,
          title: "已拼车配载",
          icon: "",
          mintitle: "年度累计",
          allNum: 0,
          unit: "单",
          background: "#fff",
        },
        {
          num: 0,
          title: "已调度",
          icon: "",
          mintitle: "年度累计",
          allNum: 0,
          unit: "单",
          background: "#fff",
        },
        {
          num: 0,
          title: "调度完成",
          icon: "",
          mintitle: "年度累计",
          allNum: 0,
          unit: "单",
          background: "#fff",
        },
      ],
      searchItem: {
        startTime: 0,
        endTime: 0,
      },
    };
  },
  methods: {
    getData(v, index) {
      ///cloud-tms-server-omc/orders/indexPendingCount
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tmsx-server-web/orders/indexRoleReportCount",
        data: v,
      }).then((res) => {
        var data = res.data.data;
        if (index == 0) {
          this.items[0].num = data.pdpzCount;
        } else if (index == 1) {
          this.items[1].num = data.dispatchCount;
        } else if (index == 2) {
          this.items[2].num = data.dispatchFinishCount;
        }
        // item.num = data.ordersMoney;
      });
    },
    getYearData(v,index) {
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tmsx-server-web/orders/indexRoleReportCount",
        data: v,
      }).then((res) => {
        var data = res.data.data;
        if (index == 0) {
          this.items[0].allNum = data.ordersMoney;
        } else if (index == 1) {
          this.items[1].allNum = data.kdkhCount;
        } else if (index == 2) {
          this.items[2].allNum = data.xkfkhCount;
        }
        // item.num = data.ordersMoney;
      });
    },
  },
};
</script>
<style>
.deskblock .blockbottom {
  display: flex;
}
.deskblock .title {
  display: flex;
}
.deskblock .title h3 {
  margin-right: auto;
}
.deskblock h2 {
  font-size: 42px;
  margin-top: 20px;
  margin-bottom: 20px;
  position: relative;
  display: inline-block;
  font-weight: bold;
}
.deskblock h2 span.unit {
  background: #fca038;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  color: white;
  display: inline-block;
  text-align: center;
  line-height: 24px;
  position: absolute;
  top: 10px;
  right: -30px;
}
.deskblock .blockbottom p:nth-child(2) {
  margin-top: -4px;
  margin-left: auto;
  min-width: 50px;
  text-align: center;
  color: #fff;
  background: #73a4f4;
  border-radius: 20px;
  line-height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/diaodu/block1.vue